<template>
  <div>
    <!-- FIXME: 画像じゃなくてCSSで描画する -->
    <img src="@/assets/img/signup/step_bar_01.png" width="100%">

    <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
      <form class="l-content" @submit.prevent="handleSubmit(submit)">
        <div class="l-container">
          <div class="p-container">
            <div>
              <div class="form-title">基本情報</div>
              <div class="u-pts">
                <span class="u-color-danger">* </span>
                <span class="u-color-gray">入力必須</span>
              </div>
            </div>

            <div class="form-row u-ptxl">
              <ValidationProvider class="u-prs form-col" name="姓" rules="required" v-slot="{ errors }">
                <TextField
                  label="姓"
                  placeholder="例）山田"
                  required
                  v-model="state.last_name"
                  input-id="last_name"
                  @input="handleLastNameInput"
                  is-publish
                  :error-message="errors[0]">
                </TextField>
              </ValidationProvider>
              <ValidationProvider class="form-col" name="名" rules="required" v-slot="{ errors }">
                <TextField
                  label="名"
                  placeholder="例）京子"
                  required
                  v-model="state.first_name"
                  input-id="first_name"
                  @input="handleFirstNameInput"
                  is-publish
                  :error-message="errors[0]">
                </TextField>
              </ValidationProvider>
            </div>

            <div class="form-row u-ptm">
              <ValidationProvider class="u-prs form-col" name="セイ" :rules="{ required: true, regex: !/^[ァ-ヶー]+$/ }" v-slot="{ errors }">
                <TextField
                  label="セイ"
                  placeholder="例）ヤマダ"
                  required
                  v-model="state.last_ruby"
                  :error-message="errors[0]">
                </TextField>
              </ValidationProvider>
              <ValidationProvider class="form-col" name="メイ" :rules="{ required: true, regex: !/^[ァ-ヶー]+$/ }" v-slot="{ errors }">
                <TextField
                  label="メイ"
                  placeholder="例）キョウコ"
                  required
                  v-model="state.first_ruby"
                  :error-message="errors[0]">
                </TextField>
              </ValidationProvider>
            </div>

            <div class="u-pts">
              <span class="u-color-gray">※お名前は応募時・メッセージ機能で公開されます。</span>
            </div>

            <div class="u-ptl">
              <ValidationProvider name="性別" rules="required" v-slot="{ errors }">
                <Dropdown
                  label="性別"
                  v-model="state.gender"
                  :options="[{ name: '男', value: 1 }, { name: '女', value: 2 }]"
                  is-publish
                  required
                  :error-message="errors[0]">
                </Dropdown>
              </ValidationProvider>
            </div>

            <div class="u-ptm">
              <BirthdayInput :value="state.birth" @change="(value) => { state.birth = value }"></BirthdayInput>
            </div>

            <div class="u-ptm">
              <ValidationProvider name="郵便番号" rules="required" v-slot="{ errors }">
                <TextField label="郵便番号" inputmode="numeric" @input="autoCompleteAddress" required v-model="state.postal" maxlength="7" :error-message="errors[0]"></TextField>
              </ValidationProvider>
            </div>

            <div class="u-ptm">
              <ValidationProvider name="都道府県" rules="required" v-slot="{ errors }">
                <Dropdown :options="prefsSelect" label="都道府県" v-model="state.pref_id" is-publish required :error-message="errors[0]"></Dropdown>
              </ValidationProvider>
            </div>

            <div class="u-ptm">
              <ValidationProvider name="市区町村" rules="required" v-slot="{ errors }">
                <TextField label="市区町村" placeholder="例）千代田区" required v-model="state.city_name" :error-message="errors[0]"></TextField>
              </ValidationProvider>
            </div>

            <div class="form-foreigner-checkbox u-ptm">
              <Checkbox class="u-prxs" id="isNotForeigner" v-model="isNotForeigner" @change="($event) => $event.target.checked ? state.nationality = 'JPN' : state.nationality = null"></Checkbox>
              <label for="isNotForeigner">外国籍ではない</label>
            </div>

            <div v-if="!isNotForeigner" class="u-ptm">
              <ValidationProvider name="国籍" rules="required" v-slot="{ errors }">
                <Dropdown label="外国籍の方は国籍を選択してください" :required="!isNotForeigner" v-model="state.nationality" :options="nationalitiesSelect"></Dropdown>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="u-ptm u-pbm">
          <HorizontalLine></HorizontalLine>
        </div>

        <div class="l-container">
          <div class="p-container">
            <div class="form-title">転職意欲</div>
            <div class="u-ptl">
              <ValidationProvider name="転職意欲" rules="required" v-slot="{ errors }">
                <Dropdown
                  :options="jobChangeSelect"
                  label="転職意欲について教えてください"
                  v-model="state.job_change_willingness"
                  required
                  is-publish
                  :error-message="errors[0]">
                </Dropdown>
              </ValidationProvider>

            </div>
          </div>
        </div>

        <div class="u-ptm u-pbm">
          <HorizontalLine></HorizontalLine>
        </div>

        <div class="l-container">
          <div class="p-container">
            <div class="form-title">副業意欲</div>
            <div class="u-ptl">
              <ValidationProvider name="副業意欲" rules="required" v-slot="{ errors }">
                <Dropdown
                  :options="sideJobSelect"
                  label="副業意欲について教えてください"
                  v-model="state.side_job_willingness"
                  required
                  is-publish
                  :error-message="errors[0]">
                </Dropdown>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="u-ptm u-pbm">
          <HorizontalLine></HorizontalLine>
        </div>

        <div class="l-container">
          <div class="p-container">
            <div class="form-title">直近の職歴</div>

            <!-- 職歴無いとき -->
            <div class="u-ptxl" v-if="occupationValid">
              <div class="form-work-history-title">
                <span>職歴</span>
              </div>
              <div class="u-ptm form-work-history-body">
                <span class="form-work-history-label">職歴を追加してください</span>
                <router-link class="form-work-history-button" :to="{ name: 'workHistory' }">
                  <i class="material-icons">add</i>
                  <span>追加</span>
                </router-link>
              </div>
              <div class="u-ptm">
                <span class="u-color-basic">※登録後に追加することも可能です。</span>
              </div>
            </div>
            <div class="u-ptm" v-else v-for="(occupation, index) in state.occupations" :key="index">
              <router-link :to="{ name: 'workHistory' }" custom v-slot="{ navigate }">
                <WorkHistoryCard :occupation="occupation" @click="navigate" role="link"></WorkHistoryCard>
              </router-link>
            </div>
          </div>
        </div>

        <div class="u-ptm u-pbm">
          <HorizontalLine></HorizontalLine>
        </div>

        <div class="l-container">
          <div class="p-container">
            <div class="form-title">パスワード設定</div>

            <div class="u-ptm">
              <ValidationProvider name="パスワード" rules="required" v-slot="{ errors }">
                <TextField label="パスワード" type="password" required v-model="state.password" :error-message="errors[0]"></TextField>
              </ValidationProvider>
            </div>

            <div class="u-ptm">
              <ValidationProvider name="パスワード確認" :rules="{ required: true, is: state.password }" v-slot="{ errors }">
                <TextField label="パスワード確認" type="password" required v-model="state.password_confirmation" :error-message="errors[0]"></TextField>
              </ValidationProvider>
            </div>

            <div class="u-pts u-color-gray">
              <span>パスワードは半角英数字8桁以上で設定してください。</span>
            </div>

            <div class="u-ptl">
              <TextField label="招待コードをお持ちの方" placeholder="例）base-Krh8Ygdfs" v-model="state.invitation_code"></TextField>
            </div>
          </div>
        </div>

        <FloatingButton type="submit" :disabled="invalid"></FloatingButton>
      </form>
    </ValidationObserver>
  </div>
</template>

<script lang="babel">
import TextField from "@/components/TextField";
import BirthdayInput from "@/components/BirthdayInput";
import FloatingButton from "@/components/button/FloatingButton";
import { mapGetters } from 'vuex'
import Dropdown from "@/components/Dropdown";
import { prefsSelect } from "@/constants/prefs";
import * as AutoKana from "vanilla-autokana";
import PublishBadge from "@/components/PublishBadge";
import Checkbox from "@/components/Checkbox";
import SliderSwitch from "@/components/SliderSwitch";
import HorizontalLine from "@/components/HorizontalLine";
import {defineComponent, onMounted, reactive, ref, inject, computed} from "vue";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {SIGNUP_STORE} from "@/constants/InjectionKeys";
import {useRouter} from "vue-router/composables";
import {useStore} from "vuex/dist/vuex.esm-browser";
import {SIDE_JOB_WILLINGNESS} from "@/constants/sideJobWillingness";
import {JOB_CHANGE_WILLINGNESS} from "@/constants/jobChangeWillingness";
import WorkHistoryCard from "@/components/signup/WorkHistoryCard";
import Postal from "@/api/postal";

let lastNameAutoKana, firstNameAutoKana;
extend('birthday', value => {
  const now = new Date();
  const birth = new Date(value);

  if (now < birth) {
    return '生年月日は現在より前に設定してください';
  }

  return true;
})

export default defineComponent({
  name: "Profile",
  components: {
    WorkHistoryCard,
    HorizontalLine,
    SliderSwitch,
    Checkbox,
    PublishBadge,
    FloatingButton,
    TextField,
    BirthdayInput,
    Dropdown,
    ValidationObserver,
    ValidationProvider
  },
  setup(_, { emit }) {
    emit('page-navbar', true);

    const userAgent = window.navigator.userAgent.toLowerCase()
    // MacのChromeはUAにSafariを含むので
    const isSafari = userAgent.indexOf('chrome') === -1 && userAgent.indexOf('safari') !== -1;
    const store = useStore()

    onMounted(() => {
      if (!isSafari) {
        lastNameAutoKana = AutoKana.bind('#last_name', '', { katakana: true });
        firstNameAutoKana = AutoKana.bind('#first_name', '', { katakana: true });
      }

      store.dispatch('signup/fetchNationalities')
    })

    const handleLastNameInput = () => {
      if (!isSafari) {
        state.last_ruby = lastNameAutoKana.getFurigana()
      }
    }
    const handleFirstNameInput = () => {
      if (!isSafari) {
        state.first_ruby = firstNameAutoKana.getFurigana()
      }
    }

    const signupStore = inject(SIGNUP_STORE)
    const router = useRouter()

    const state = reactive(signupStore.worker)
    const isNotForeigner = ref((state.nationality || 'JPN') === 'JPN')
    const submit = () => {
      signupStore.setWorker(state)
      router.push({ name: 'preview' });
    }

    const autoCompleteAddress = () => {
      // 日本の郵便番号は7桁なので
      if (state.postal != null && state.postal.length === 7) {
        Postal.search({ code: state.postal }).then((response) => {
          const payload = response.data.payload;
          state.pref_id = payload.pref
          state.city_name = payload.city_name
        }).catch(() => {
          // MEMO: 存在しないコード入れたときもここに入るので、sentry対策として一応
        })
      }
    }

    return {
      state,
      prefsSelect: prefsSelect(),
      sideJobSelect: SIDE_JOB_WILLINGNESS,
      jobChangeSelect: JOB_CHANGE_WILLINGNESS,
      occupationValid: computed(() => (state.occupations || []).length <= 0),
      isNotForeigner,
      handleLastNameInput,
      handleFirstNameInput,
      autoCompleteAddress,
      submit
    }
  },
  computed: {
    ...mapGetters('signup', ['nationalities']),
    nationalitiesSelect() {
      const nationalities = this.nationalities.map((nationality) => ({ name: nationality.name, value: nationality.code }));
      nationalities.splice(0, 1); // 日本人以外の選択なので、日本を削除

      return nationalities;
    },
  }
})
</script>

<style scoped lang="scss">
.form {
  &-title {
    font-weight: bold;
    font-size: 18px;
    line-height: 18px;
  }

  &-row {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-col {
    flex: 1;
  }

  &-foreigner-checkbox {
    display: flex;
    align-items: center;
  }

  &-biz-publish {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .label {
      margin-right: auto;
    }
  }

  &-publish-section {
    line-height: 28px;
  }

  &-publish-badge {
    font-size: 10px;
  }

  &-work-history {
    &-title {
      color: #CAC9C9;
    }
    &-label {
      margin-right: auto;
    }
    &-body {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    &-button {
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      background: #F94848;
      border-radius: 30px;
      padding: 8px 11px;
      text-decoration: none;
      i {
        font-size: 12px;
        line-height: 12px;
      }
      span {
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
}
</style>
